import { render, staticRenderFns } from "./BattleForm.vue?vue&type=template&id=76fd6626&scoped=true&lang=pug&"
import script from "./BattleForm.vue?vue&type=script&lang=js&"
export * from "./BattleForm.vue?vue&type=script&lang=js&"
import style0 from "./BattleForm.vue?vue&type=style&index=0&id=76fd6626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd6626",
  null
  
)

export default component.exports